import React, { Component } from 'react';
import Select from '../forms/select';
import Checkbox from '../forms/checkbox';

class MapPostFields extends Component {
  state = {};
  render() {
    const { fields, onFieldChange } = this.props;

    return (
      <div className="gb-settings-container">
        {fields.map(field => {
          if (field.type === 'select') {
            return (
              <Select
                key={field.name}
                label={field.label}
                name={field.name}
                value={field.value}
                options={field.options}
                onChange={onFieldChange}
              />
            );
          } else if (field.type === 'checkbox') {
            return (
              <Checkbox
                key={field.name}
                label={field.label}
                name={field.name}
                value={field.value}
                placeholder={field.placeholder}
                onChange={onFieldChange}
              />
            );
          } else {
            return 'No field type found';
          }
        })}
      </div>
    );
  }
}

export default MapPostFields;



// WEBPACK FOOTER //
// ./src/components/settings/mapPostFields.jsx